import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { cn } from '@utils/cn';
import { CloseButtonProps } from './types';

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ className, ...props }, ref) => {
    const { t } = useTranslation('app');

    return (
      <button
        ref={ref}
        type="button"
        aria-label={t('actions.close')}
        className={cn(
          'flex h-10 w-11 shrink-0 items-center justify-center rounded-md border border-neutral-100 bg-[#f6f7fb] text-neutral-800 active:bg-neutral-50',
          className,
        )}
        {...props}>
        <X className="h-[18px] w-[18px]" strokeWidth={2} />
      </button>
    );
  },
);
// eslint-disable-next-line immutable/no-mutation
CloseButton.displayName = 'CloseButton';
